import { combineReducers } from "redux"
import postsReducer from "./posts"
import authReducer, { getAuthInitialState } from "./auth"
import userReducer from "./user"
import guidesReducer from "./guides"
import tripsReducer from "./trips"
import favouriteTripsReducer from "./favourite-trips"
import accountingReducer from "./accounting"
import conversationsReducer from "./conversations"
import passwordReducer from "./password"
import lightboxReducer from "./lightbox"
import windowReducer from "../modules/window/reducer"
import weatherReducer from "./weather"
import bookingsReducer from "./bookings"
import reviewsReducer from "./reviews"
import boatsReducer from "./boats"
import clientsReducer from "./clients"
import dashboardReducer from "./dashboard"
import unavailableDaysReducer from "./unavailable-days"
import templatesReducer from "./templates"
import contactUsReducer from "./contact-us"
import textGenerateReducer from "./text-generate"
import proWizardMenuReducer from "./pro-wizard-menu"
import proHomeMenuReducer from "./pro-home-menu"
import errorsReducer from "modules/errors/reducer"
import successReducer from "modules/success/reducer"
import modalsReducer from "modules/modals/reducer"
import loaderWatchersReducer from "modules/loader-watchers/reducer"
import partnerReducer from "./partner"
import googleCalendarReducer from "./google-calendar"
import groupsReducer from "./groups"
import experiencesReducer from "./experiences"
import chatCardReducer from "./aiassistant"
import confirmPasswordReducer from "./confirm-password"
import calendarReducer from "./calendar"
import crewMemberCalendarReducer from "./crewMemberCalendar"
import crewMemberJournalReducer from "./crewMemberJournal"
import equipmentJournalReducer from "./equipmentJournal"
import proNewListingFormsReducer from "./proNewListingForms"
import guideProfileReducer from "./guide-profile"
import locationReducer from "./location"
import countriesReducer from "./countries"
import updateEmailPhoneNumberReducer from "./update-email-phone-number"
import paymentProviderReducer from "./payment-provider"
import digitalWaiverReducer from "./digital-waiver"
import staffReducer from "./staff"
import staffAssignmentsReducer from "./staffAssignments"
import equipmentAssignmentsReducer from "./equipmentAssignments"

import questionReducer from "./question"
import rolesReducer from "./roles"
import crewProfilesReducer from "./crew-profiles"
import customFeesReducer from "./custom-fees"
import addOnsReducer from "./add-ons"
import discountsReducer from "./discounts"
import platformFeesReducer from "./platform-fees"
import guestAccessReducer from "./guest-access"
import emailDomainReducer from "./email-domain"
import aiDashboardReducer from "./aiDashboard"
import experiencesUiReducer from "./experiencesUi"
import communicationReducer from "./communication"
import communicationTemplatesReducer from "./communicationTemplates"
import shortLinkReducer from "./short-link"
import reservationsReducer from "./reservations"
import upcomingExperiencesReducer from "./upcomingExperiences"
import { RESET_APP } from "./actions"

const appReducer = combineReducers({
  auth: authReducer,
  password: passwordReducer,
  user: userReducer,
  guides: guidesReducer,
  reviews: reviewsReducer,
  dashboard: dashboardReducer,
  unavailableDays: unavailableDaysReducer,
  bookings: bookingsReducer,
  clients: clientsReducer,
  boats: boatsReducer,
  trips: tripsReducer,
  favouriteTrips: favouriteTripsReducer,
  conversations: conversationsReducer,
  accounting: accountingReducer,
  posts: postsReducer,
  templates: templatesReducer,
  weather: weatherReducer,
  contactUs: contactUsReducer,
  modals: modalsReducer,
  errors: errorsReducer,
  success: successReducer,
  lightbox: lightboxReducer,
  window: windowReducer,
  loaderWatchers: loaderWatchersReducer,
  textGenerate: textGenerateReducer,
  proWizardMenu: proWizardMenuReducer,
  proHomeMenu: proHomeMenuReducer,
  googleCalendar: googleCalendarReducer,
  groups: groupsReducer,
  experiences: experiencesReducer,
  partner: partnerReducer,
  chatCard: chatCardReducer,
  confirmPassword: confirmPasswordReducer,
  calendar: calendarReducer,
  crewMemberCalendar: crewMemberCalendarReducer,
  crewMemberJournal: crewMemberJournalReducer,
  equipmentJournal: equipmentJournalReducer,
  guideProfile: guideProfileReducer,
  updateEmailPhoneNumber: updateEmailPhoneNumberReducer,
  proNewListingForms: proNewListingFormsReducer,
  location: locationReducer,
  countries: countriesReducer,
  paymentProvider: paymentProviderReducer,
  digitalWaiver: digitalWaiverReducer,
  question: questionReducer,
  staff: staffReducer,
  staffAssignments: staffAssignmentsReducer,
  equipmentAssignments: equipmentAssignmentsReducer,
  roles: rolesReducer,
  crewProfiles: crewProfilesReducer,
  guestAccess: guestAccessReducer,
  emailDomain: emailDomainReducer,
  customFees: customFeesReducer,
  addOns: addOnsReducer,
  discounts: discountsReducer,
  platformFees: platformFeesReducer,
  aiDashboard: aiDashboardReducer,
  experiencesUi: experiencesUiReducer,
  communication: communicationReducer,
  communicationTemplates: communicationTemplatesReducer,
  shortLink: shortLinkReducer,
  reservations: reservationsReducer,
  upcomingExperiences: upcomingExperiencesReducer,
})

const rootReducer = (state, action) => {
  if (action.type === RESET_APP) {
    // Reset all slices to initial state, but recompute auth from current localStorage
    const baseState = appReducer(undefined, action)
    return { ...baseState, auth: getAuthInitialState() }
  }
  return appReducer(state, action)
}

export default rootReducer
